import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Division } from '../../../models/division';
import { Area } from '../../../models/area';
import { AlertaService } from '../../../services/alerta.service';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { ActivatedRoute } from '@angular/router';
import { FormulaGroup } from '../../../models/formulas/formula-group';
import { Variable } from '../../../models/formulas/variable';
import { ObjectF } from '../../../models/formulas/object';
import { FormulaConfiguration } from '../../../models/formulas/formula-configuration';
import { findFormulaGroupAct, resetFormulaGroupAct, saveFormulaGroupAct, updateFormulaGroupAct } from '../../../store/formula-group/formula-group.action';
import { findObjectsCatalogAct, findVariablesCatalogAct } from '../../../store/catalog-offer/catalog-offer.actions';

@Component({
  selector: 'app-formulas-add',
  standalone: false,
  templateUrl: './formulas-add.component.html',
  styleUrl: './formulas-add.component.css'
})
export class FormulasAddComponent {

  formulaGroupForm!: NgForm;
  formulaGroup: FormulaGroup = new FormulaGroup();
  loading: boolean = false;
  violations: any;
  //divisions: Division[] = [];
  //areas: Area[] = [];
  variables: Variable[] = [];
  objects: ObjectF[] = [];
  private alerta = inject(AlertaService);
  
  ngOnInit(): void {
    this.formulaGroupStore.dispatch(resetFormulaGroupAct());
    this.route.paramMap.subscribe(params => {
      const id: number = + (params.get('id') || '0');
      if(id > 0){
        this.formulaGroupStore.dispatch(findFormulaGroupAct({ id }));
      }else{
        this.formulaGroup = new FormulaGroup();
        //this.formulaGroup.active = true;
        this.loading = false;
      }
    });

    //this.catalogOfferStore.dispatch(findDivisionsCatalogAct());
    //this.catalogOfferStore.dispatch(findAreasCatalogAct());
    this.catalogOfferStore.dispatch(findVariablesCatalogAct());
    this.catalogOfferStore.dispatch(findObjectsCatalogAct());

  }
  constructor(
    private formulaGroupStore: Store<{formulaGroupRdc: any}>,
    private catalogOfferStore: Store<{catalogOfferRdc: any}>,
    private route: ActivatedRoute,
    private cd: ChangeDetectorRef
  ){
    this.formulaGroup = new FormulaGroup();

    this.formulaGroupStore.pipe(
      select('formulaGroupRdc'),
      map(state => ({ // filtra cuando cambian las propiedades que se usan en este componente
        formulaGroup: state.formulaGroup,
        violations: state.violations,
        loading: state.loading
      })),
      // evita repeticiones
      distinctUntilChanged((prev, curr) =>
        JSON.stringify(prev) === JSON.stringify(curr)
      )
    ).subscribe(({ formulaGroup, violations, loading }) => {
      this.violations = violations;
      this.formulaGroup = JSON.parse(JSON.stringify(formulaGroup));
      // Ordenar lista de vacaciones 
      this.formulaGroup.formulaConfigurations.sort((a, b) =>  a.variable.description.localeCompare(b.variable.description, 'es', { sensitivity: 'base' }) );
      /*this.formulaGroup.formulaConfigurations.forEach(formulaConfiguration => {
        formulaConfiguration.sort((a, b) => a.initialYear - b.initialYear);
      });*/
      this.loading = loading;
      this.cd.markForCheck(); // fuerza la actualización de la vista

      if(this.formulaGroupForm){
        Object.keys(this.formulaGroupForm.controls).forEach(controlName => {
          const control = this.formulaGroupForm.controls[controlName];
          if (this.violations[controlName]) {
            control.setErrors({ backend: true }); // Marca error
          }
        });
      }
    });

    this.catalogOfferStore.pipe(
      select('catalogOfferRdc'),
      map(state => ({ // filtra cuando cambian las propiedades que se usan en este componente
        //divisions: state.divisions,
        //areas: state.areas,
        variables: state.variables,
        objects: state.objects
      })),
      // evita repeticiones
      distinctUntilChanged((prev, curr) =>
        JSON.stringify(prev) === JSON.stringify(curr)
      )
    ).subscribe(({ variables, objects }) => {
      //this.divisions = divisions;
      //this.areas = areas;
      this.variables = variables;
      this.objects = objects;
    });
    
  }

  onSubmitFormulaGroup(formulaGroupForm: NgForm): void {
    this.loading = true;
    this.formulaGroupForm = formulaGroupForm;
    const formulaGroupCopy = JSON.parse(JSON.stringify(this.formulaGroup));

    if (formulaGroupCopy.id > 0) {
      this.formulaGroupStore.dispatch(updateFormulaGroupAct({ formulaGroupUpdated: formulaGroupCopy }))
    } else {
      this.formulaGroupStore.dispatch(saveFormulaGroupAct({ formulaGroupNew: formulaGroupCopy }))
    }
  }
 
  addFormulaConf(){
    const newFormulaConfigurations = new FormulaConfiguration();
    this.formulaGroup.formulaConfigurations = [...this.formulaGroup.formulaConfigurations, newFormulaConfigurations ];
  }

    /*hoveredRow: number | null = null;
    hoveredCol: number | null = null;

    isSelected(listIndex: number, divisionId: number, areaId: number): boolean {
      const list = this.formulaGroup.formulaConfigurations?.[listIndex];
      return list?.formulaDivisionAreaList.some(d =>
        d.id.divisionId === divisionId && d.id.areaId === areaId
      ) ?? false;
    }

    onCheckboxChange(listIndex: number, division: Division, area: Area, event: any): void {
      const checked = event.target.checked;
      const list = this.formulaGroup.formulaConfigurations?.[listIndex];
      if (!list) return;
    
      const index = list.formulaDivisionAreaList.findIndex(d =>
        d.id.divisionId === division.id && d.id.areaId === area.id
      );
    
      if (checked && index === -1) {
        // Agrega nuevo vínculo
        list.formulaDivisionAreaList.push({
          id: {
            holidayListId: list.id,
            divisionId: division.id,
            areaId: area.id
          },
          division,
          area
        });
      } else if (!checked && index !== -1) {
        // Elimina vínculo
        list.formulaDivisionAreaList.splice(index, 1);
      }
    }
    onMouseEnter(row: number, col: number) {
      this.hoveredRow = row;
      this.hoveredCol = col;
    }
  
    onMouseLeave() {
      this.hoveredRow = null;
      this.hoveredCol = null;
    }*/

    compareVariable = (a: any, b: any) => a?.id === b?.id;
    compareObject = (a: any, b: any) => a?.id === b?.id;
}
